import { ConfigurationColors } from '@tink/config/src/tinkLinkConfig';

type Props = Partial<Pick<ConfigurationColors, 'primaryColor'>>;

export const PaymentIcon = ({ primaryColor }: Props) => (
  <svg width="31" height="46" viewBox="0 0 31 46" fill="none">
    <rect x="1" y="1" width="24" height="44" rx="2.604" stroke={primaryColor} strokeWidth="1.5" />
    <rect x="8" y="3" width="10" height="2" rx="1" fill={primaryColor} />
    <rect x="4" y="12" width="18" height="6" rx="1" fill={primaryColor} />
    <circle cx="23" cy="34" r="8" fill={primaryColor} />
    <path d="M19 33.4294L22.1224 37L28 30" stroke="white" strokeWidth="1.5" />
  </svg>
);
